import { render, staticRenderFns } from "./LapsedPayPlanDrawer.vue?vue&type=template&id=5750e15a&scoped=true"
import script from "./LapsedPayPlanDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./LapsedPayPlanDrawer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LapsedPayPlanDrawer.vue?vue&type=style&index=0&id=5750e15a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5750e15a",
  null
  
)

export default component.exports